// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  apiUrl :"https://muvmadebmf.execute-api.us-east-1.amazonaws.com/prod",
  // omniAPIUrl:"http://localhost:9000/api",
  omniAPIUrl:'https://qa-api.omnibotlearn.com/api', // QA
  // omniAPIUrl:"https://api.omnicoe.com/api", // PROD
  webkitURL:"https://omni-qa-e5ce5.web.app/",
  // webkitURL:"https://app.omnicoe.com/",
  production: false
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
